export default "__VITE_ASSET__8PfUdjIr__"